/**
 * Collection Infinite Scroll
 * Loads more products as user scrolls near bottom
 * Shows skeleton placeholders during loading
 */

(function() {
  'use strict';

  const LOAD_THRESHOLD = 400; // px from bottom to trigger load

  class CollectionInfiniteScroll {
    constructor() {
      this.grid = document.querySelector('[data-collection-grid]');
      this.skeletons = document.querySelector('[data-collection-skeletons]');
      this.loader = document.querySelector('[data-collection-loader]');
      this.trigger = document.querySelector('[data-next-page]');
      
      if (!this.grid || !this.trigger) return;
      
      this.nextPageUrl = this.trigger.dataset.nextPage;
      this.isLoading = false;
      this.hasMore = !!this.nextPageUrl;
      
      this.init();
    }

    init() {
      // Use Intersection Observer for efficient scroll detection
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && this.hasMore && !this.isLoading) {
              this.loadMore();
            }
          });
        },
        {
          rootMargin: `${LOAD_THRESHOLD}px`,
          threshold: 0
        }
      );

      if (this.loader) {
        this.observer.observe(this.loader);
      }
    }

    async loadMore() {
      if (this.isLoading || !this.hasMore) return;
      
      this.isLoading = true;
      this.showSkeletons();

      try {
        const response = await fetch(this.nextPageUrl);
        const html = await response.text();
        
        // Parse the response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Get new products
        const newProducts = doc.querySelectorAll('[data-product-card]');
        
        // Get next page URL
        const newTrigger = doc.querySelector('[data-next-page]');
        
        // Hide skeletons before appending
        this.hideSkeletons();
        
        // Append new products to grid
        newProducts.forEach(product => {
          // Update lazy loading for new images
          const images = product.querySelectorAll('img[loading="eager"]');
          images.forEach(img => img.setAttribute('loading', 'lazy'));
          
          this.grid.appendChild(product);
        });

        // Update next page URL
        if (newTrigger) {
          this.nextPageUrl = newTrigger.dataset.nextPage;
          this.trigger.dataset.nextPage = this.nextPageUrl;
        } else {
          this.hasMore = false;
          if (this.loader) {
            this.loader.style.display = 'none';
          }
        }

      } catch (error) {
        console.error('Error loading more products:', error);
        this.hideSkeletons();
      }

      this.isLoading = false;
    }

    showSkeletons() {
      if (this.skeletons) {
        // Move skeletons after the grid
        this.grid.parentNode.insertBefore(this.skeletons, this.loader);
        this.skeletons.style.display = 'grid';
      }
    }

    hideSkeletons() {
      if (this.skeletons) {
        this.skeletons.style.display = 'none';
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CollectionInfiniteScroll());
  } else {
    new CollectionInfiniteScroll();
  }
})();
